<template>
  <div>
    <nav class="fixed-top navbar navbar-light navbar-expand-lg " id="mainNav">
        <a class="navbar-brand">MR</a>
        <button
          data-toggle="collapse"
          data-target="#navbarResponsive"
          class="navbar-toggler"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i class="fa fa-bars"></i>
        </button>
        <div class="collapse navbar-collapse pt-3" id="navbarResponsive">
          <!-- MENU DE NAVEGACION -->
          <ul class="nav navbar-nav ml-auto " id="menu-v8">
            <li class="nav-item pb-3" role="presentation">
              <!-- REEMPLAZAR CON ELEMENTO ROUTER LINK A CON RUTA NOMBRADA -->
              <router-link :to="{ name: 'inicio' }">Inicio</router-link> 
            </li>
            <li class="nav-item pb-3" role="presentation">
              <!-- REEMPLAZAR CON ELEMENTO ROUTER LINK A CON RUTA NOMBRADA -->
              <router-link :to="{ name: 'sobreMiLL' }">Nosotros</router-link> 
            </li>
            <li class="nav-item pb-3" role="presentation">
              <!-- REEMPLAZAR CON ELEMENTO ROUTER LINK A RUTA ESTÁTICA -->
              <router-link to="/Portafolio">PORTAFOLIO</router-link> 
            </li>

            <li class="nav-item pb-3" role="presentation">
              <!-- REEMPLAZAR CON ELEMENTO ROUTER LINK A CON RUTA ESTÁTICA -->
              <router-link to="/Servicios">Servicios</router-link> 
            </li>
          </ul>
        
      </div>
    </nav>


    
    
    <transition name="transicion-v8">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#menu-v8 a {
  /* text-shadow: 1px 1px #000; */
}
.transicion-v8-enter-active,
.transicion-v8-leave-active {
  transition: opacity 0.5s; /*queda mas bonito con .5 que con .1*/
}
.transicion-v8-enter,
.transicion-v8-leave-to {
  opacity: 0;
}

.nav-item{

  color: white;

}

.navbar-brand {
  font-size: 30px !important;
  padding-right: 20px;
}
a:hover {
    color: #610f8b !important;
}

#mainNav .navbar-nav > li.nav-item > a:hover {
     border-bottom: 1px solid #610f8b !important;

}

a {
  color: #610f8b
}
</style>
